// Values for a message's {placeholders}.
export type Params = { [name: string]: string | number | boolean };

const bytes = new Intl.NumberFormat(undefined, { maximumFractionDigits: 1 });

// Fills a catalogue message's {placeholders} from params: {name} as it is, {name:bytes} as a size (10 MB), {name:list}
// as a list (the API joins choices with |). A placeholder without a value is left out.
export function format(template: string, params?: Params): string {
    return template.replace(/\{(\w+)(?::(\w+))?\}/g, (_, name: string, style?: string) => {
        const value = params?.[name];
        if (value === undefined) {
            return '';
        }
        if (style === 'bytes' && typeof value === 'number') {
            return value >= 1024 * 1024 ? `${bytes.format(value / (1024 * 1024))} MB` : `${bytes.format(value / 1024)} KB`;
        }
        if (style === 'list') {
            return String(value).split('|').join(', ');
        }
        return String(value);
    });
}
